import {
  SwapCard,
  useSwapContext,
  useTokenListContext,
} from "@cyclos-io/swap-ui";
import { useWalletKit } from "@gokiprotocol/walletkit";
import { Box, Hidden, useMediaQuery } from "@material-ui/core";
import useTheme from "@material-ui/core/styles/useTheme";
import { TokenInfo } from "@solana/spl-token-registry";
import { PublicKey } from "@solana/web3.js";
import { useEffect } from "react";
import AreaChart from "../components/Chart";
import OfferInfo from "../components/OfferInfo";
import { CYSaddress } from "../constants";

export default function SwapPage() {
  const theme = useTheme();
  const upMd = useMediaQuery(theme.breakpoints.up("md"));
  const downXs = useMediaQuery(theme.breakpoints.down("xs"));

  const { connect } = useWalletKit();
  const { fromMint, toMint, setFromMint, setToMint, showReversePrices } =
    useSwapContext();

  const { tokenMap } = useTokenListContext();

  let fromTokenInfo: TokenInfo | undefined = tokenMap.get(
    showReversePrices ? toMint.toString() : fromMint.toString()
  );
  let toTokenInfo: TokenInfo | undefined = tokenMap.get(
    showReversePrices ? fromMint.toString() : toMint.toString()
  );

  useEffect(() => {
    // Sol
    setToMint(new PublicKey("Ejmc1UB4EsES5oAaRN63SpoxMJidt3ZGBrqrZk49vjTZ"));
    // USDC
    setFromMint(new PublicKey("EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"));
  }, []);

  return (
    <Box
      display="flex"
      height="auto"
      justifyContent="center"
      style={{ gap: "1rem" }}
    >
      <Hidden smDown>
        <AreaChart fromTokenInfo={fromTokenInfo} toTokenInfo={toTokenInfo} />
      </Hidden>
      <Box display="flex" flexDirection="column" alignItems="center" my={2}>
        <SwapCard
          swapTokenContainerStyle={{
            // boxShadow: "0px 0px 0px 0px", // No shadow
            boxShadow: "rgba(0, 0, 0, 0.1) 1px 3px 5px",
            backgroundColor: "#181b2a7d",
            border: "1px solid #1a1d2d",
            borderRadius: theme.spacing(0.8),
          }}
          contentStyle={{}}
          containerStyle={{
            borderRadius: theme.spacing(0.8),
            width: `${upMd ? "40vw" : downXs ? "90vw" : "70vw"}`,
            marginRight: "auto",
            marginLeft: "auto",
            maxWidth: "440px",
            // border: "3px solid #7C80B9",
          }}
          swapButtonStyle={{
            borderRadius: theme.spacing(0.8),
          }}
          connectWalletCallback={() => connect()}
        />
        <Hidden mdUp>
          <AreaChart fromTokenInfo={fromTokenInfo} toTokenInfo={toTokenInfo} />
        </Hidden>
      </Box>
    </Box>
  );
}
